export interface apiPageObject {
  id: string;
  slug: string;
  title: string;
  collections: apiCollection[];
}

export interface apiCollectionRoot {
  collection: apiCollection;
  total: number;
}
export interface apiCollection {
  id: string;
  slug: string;
  name: string;
  description: any;
  position: number;
  showInCollections: boolean;
  isTop: boolean;
  collectionFictions: apiCollectionFiction[];
}

export type apiChartsList = apiChart[];

export interface apiChart {
  id: string;
  name: string;
  isShowed: boolean;
  countries: apiCountry[];
}

export interface apiCountry {
  id: string;
  name: string;
  fictions: apiCollectionFiction[];
}

export interface apiCollectionFiction {
  id: string;
  position: number;
  fiction: apiFiction;
}

export interface apiFiction {
  id: string;
  kind: string;
  slug: string;
  movieImdbid: string;
  serialImdbid: any;
  checked: boolean;
  studios: apiStudio[];
  genres: apiGenre[];
  movie: apiMovie;
  serial: apiSerial;
  casts: apiPerson[];
  writers: apiPerson[];
  directors: apiPerson[];
}

export interface apiStudio {
  imdbid: string;
  studioName: string;
  description: any;
}

export interface apiGenre {
  id: string;
  slug: string;
  genreName: string;
}

export interface apiMovie {
  imdbid: string;
  title: string;
  portraitImage: string;
  placeholderImage: any;
  description: string;
  fullDescription: string;
  voteCount: number;
  rating: number;
  ageRestriction: number;
  releaseDate: string;
  releaseYear: number;
  addedAt: string;
  runtime: number;
  previewVideoUrl: any;
  isUpdated: boolean;
  audioTracks: apiAudioTrack[];
  subtitleTracks: apiSubtitleTrack[];
  fiction: apiFiction;
  country: string;
}

export interface apiSerial {
  imdbid: string;
  title: string;
  seasonsCount: number;
  episodesCount: number;
  portraitImage: string;
  placeholderImage?: string;
  description: string;
  fullDescription: string;
  voteCount: number;
  rating: number;
  ageRestriction: number;
  releaseDate: string;
  releaseYear: number;
  endYear?: number;
  addedAt: string;
  isUpdated: boolean;
  updatedAt: string;
  fiction: apiFiction;
  country: string;
  seasons: apiSeason[];
  audioTracks: apiAudioTrack[];
  subtitleTracks: apiSubtitleTrack[];
}

export interface apiSeason {
  id: string;
  position: number;
  episodesCount: number;
  serialImdbid: string;
}

export interface apiEpisode {
  imdbid: string;
  title: string;
  slug: string;
  portraitImage: string;
  placeholderImage: any;
  description: string;
  voteCount: number;
  rating: number;
  releaseDate: string;
  releaseYear: number;
  runtime: number;
  position: number;
  isShown: boolean;
  seasonId: string;
  serialImdbid: string;
}

export interface apiAudioTrack {
  id: string;
  m3u8Id: string;
  originalName: string;
  name: string;
  kind: string;
  visible: boolean;
  movieId: string;
  episodeId: any;
}

export interface apiSearchResponse {
  results: apiSearchResultFiction[];
  pagination: apiPagination;
}

export interface apiSearchResultFiction {
  imdbid: string;
  title: string;
  portraitImage: string;
  voteCount: number;
  rating: number;
  ageRestriction: number;
  releaseDate: string;
  releaseYear: number;
  runtime: number;
  fiction: apiFiction;
  type: string;
}

export interface apiPagination {
  page: number;
  limit: number;
  totalResults: number;
  totalPages: number;
}

export interface apiSubtitleTrack {
  id: string;
  m3u8Id: string;
  name: string;
  visible: boolean;
  originalName: string;
  mediaKind: string;
  movieId: string;
  episodeId: any;
}

export interface apiPerson {
  imdbid: string;
  personName: string;
  photoUrl: string;
}

export interface apiAuthRoot {
  user: apiUser;
  accessToken: string;
}

export interface apiUser {
  id: string;
  email: string;
  userName: string;
  avatarUrl: any;
  location: any;
  verified: string;
  role: string;
  language: string;
  isBanned: boolean;
  subscriptionExpired: any;
  currentSubscription: any;
  createdAt: string;
}

export interface FictionState {
  position: number;
  duration: number;
  audio: string;
  sub: string;
  seasonNumber: string;
  episodeNumber: string;
}

export enum PagesEnum {
  HOME,
  SERIALS,
  MOVIES,
  COLLECTIONS,
  SEARCH,
}
